import { useRouter } from 'next/router'
import { useEffect } from 'react'
import { LOGIN } from '@fe/common/constants/routes'

export const useDelayedNavigate = (route: string = LOGIN, timeout = 5000) => {
  const { push } = useRouter()

  useEffect(() => {
    const timeoutRef = setTimeout(() => {
      push(route)
    }, timeout)

    return () => {
      clearTimeout(timeoutRef)
    }
  }, [])
}
